import React, { useEffect, useState } from 'react';
import ActivePolls from '../../components/ActivePolls/ActivePolls';
import './Dashboard.scss';
import {API_URL} from '../../utils/axios'
import axios from 'axios'
import { withRouter } from 'react-router-dom';

const Dashboard = () => {
    const [loading, setLoading] = useState(true);
    const [polls, setPolls] = useState();
    useEffect(() => {
        axios.defaults.headers['foodrtoken'] = localStorage.getItem("token")
        
        axios.get(API_URL + '/poll/get/all').then(response => {
            setPolls(response.data)
            setLoading(false)
        }).catch(error => console.log(error))
     
    }, [])


    return (
            <div className="dashboard">
                <div className="dashboard__active-polls">
                     {!loading &&  <ActivePolls polls={polls}/>}
                </div>
           </div>
    );
};

export default withRouter(Dashboard);
